import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-magic-line c-magic-line--underline text-dusty-grey hover:text-mine-shaft" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PdfLinkIconAndLabel',
  props: {
    label: null,
    hideIcon: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.hideIcon)
      ? (_openBlock(), _createBlock(_component_c_icon, {
          key: 0,
          name: "icon-pdf",
          title: __props.label,
          class: "lg:-mt-3 mr-x1 text-dusty-grey hover:text-mine-shaft"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1)
  ], 64))
}
}

})